import Vue from 'vue'
// @ts-ignore
import Tooltip from 'vue-directive-tooltip'

export default function () {
  Vue.use(Tooltip)
}
